// @flow
import { handlePaginatedMapRequest } from '../phasedActionHelpers';

import type { LoadComposersAction } from '../../actions/composer';

export type State = {
  +[key: string]: {|
    +loading: boolean,
    +loaded: boolean,
    +loadedCursors: { [key: string]: boolean },
    +entities: Array<number>,
    +meta: {
      +count: number,
      +cursor: { +next: ?string, +prev: ?string },
    },
  |},
};

const initialState = {};

export default function composers(state: State = initialState, action: LoadComposersAction) {
  if (action.type === 'FETCH_COMPOSERS' && action.cacheId) {
    return handlePaginatedMapRequest(state, action, action.cacheId);
  }

  return state;
}
